import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { PageName, RsRoute } from '@Pages/RetroSynthesis/routes';
import { ButtonWithIcon } from '@els/els-react--button';

import './RsProjectRouteRightHandLinks.scss';

function RsProjectRouteRightHandLinks({ projectId, routeId, onRouteViewClick }) {
  const history = useHistory();
  function navigationClickHandler(page) {
    onRouteViewClick(routeId);
    if (PageName.TREE_VIEW === page) {
      history.push(RsRoute.getProjectRouteTreeViewLink(projectId, routeId));
    }
  }
  const treeViewOnClickHandler = () => {
    navigationClickHandler(PageName.TREE_VIEW);
  };
  return (
    <div className="project-route-right-hand-links">
      <ButtonWithIcon
        data-e2e="project-route-tree-view"
        id={`project-route-right-hand-link-${routeId}`}
        type="primary"
        size="small"
        sprite="ChevronRight"
        linkIconSize="s"
        iconRight
        onClick={treeViewOnClickHandler}
        className="project-route-right-hand-link e2e-project-route-right-hand-link-tree-view">
        Tree view
      </ButtonWithIcon>
    </div>
  );
}

RsProjectRouteRightHandLinks.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // Number ??
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onRouteViewClick: PropTypes.func,
};

export default RsProjectRouteRightHandLinks;
